/**
 * changelogReleases.js — SAFE LOCAL FALLBACK for /whats-new.
 *
 * IMPORTANT: This file is NOT the production source of truth for
 * the public What's New / changelog page. The live
 * `/api/integrations/ecosystem/changelog` endpoint is. This module
 * only exposes a SAFE corporate scaffold so the page never renders
 * blank if the live feed is unreachable.
 *
 * Fallback rules (owner directive 2026-02-02):
 *   - SAFE PUBLIC CORPORATE CONTENT ONLY.
 *   - Customer-positive framing.
 *   - No internal release notes.
 *   - No banned wording (Financial Services / payment services /
 *     remittance / FSA-regulated / bank-grade).
 *
 * Shape is the JTR UI-kit shape (preserved 1-for-1).
 */

export const RELEASES = [
  {
    version: "site.2.0",
    type: "Feature Release",
    date: "Feb 2, 2026 (JST)",
    latest: true,
    title: {
      en: "Public corporate site — phase 2",
      ja: "公式コーポレートサイト — フェーズ2",
    },
    desc: {
      en: "The NoJo Enterprise public corporate site moved into its phase 2 layout, with bilingual EN/JA pages for About, Services, Who We Serve, Our Approach, What's New, Roadmap and Contact.",
      ja: "NoJo Enterpriseの公式コーポレートサイトをフェーズ2へ刷新しました。会社情報・運営サービス・支えるお客様・私たちの取り組み・最新情報・ロードマップ・お問い合わせの各ページをバイリンガル（日本語・英語）で公開しています。",
    },
    changes: [],
  },
];
